/*
 * @Description: '成功案例'河南广播电视台的路由设置
 * @Author: 贾博宁
 * @Date:202 -05
*/

export default [
    {
        path: '/cgal_hntv',
        component: resolve => require(['@/views/cgal_hntv'], resolve),
        name: 'cgal_hntv',
        meta: {
            nav: '河南一建'
        }
    }

]



// WEBPACK FOOTER //
// ./src/router/cgal_hntv.js